import axios from "axios"
import { api_protocolo_url } from "./Urls"


export const ApiProtocoloEletronico = axios.create({
    baseURL: api_protocolo_url
});

export const RegistroProtocoloEletronico = async (id_usuario: number, token: string) => {
    try {
        ApiProtocoloEletronico.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        const registra = await ApiProtocoloEletronico.post(`/contato/registra-por-id/${id_usuario}`)
    } catch (e) {
        console.log(e);
    }
}

